import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Button, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { forgotPassword } from './cognito-auth';
import { doLogout } from '../../actions/login/index';
import Loading from '../common/Loading';
import { commonRenderInput } from '../../components/common/access-form';
import { verifyForm, verifyAccount, minLength8, verifyPasswordConsistent } from '../../components/common/access-form-validation';

class ForgotPwdForm extends Component {

  state = {
    cognitoUser: null,
    displayChangeForm: false,
    loading: false
  }

  // first submit will check email and show second form
  forgotPwdSubmit = (values) => {
    let email = values.inputVerifyEmail;
    if (email) {
      this.setState({ loading: true });

      let doConfirm = new Promise((resolve, reject) => {        
        let forgotPasswordConfirm = (cognitoUser) => {
          resolve(cognitoUser);
        };
        // call cognito api
        forgotPassword(email, forgotPasswordConfirm, reject);
      });

      doConfirm
      .then((cognitoUser) => {
          this.setState({ cognitoUser: cognitoUser, displayChangeForm: true, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
        alert(err.message);
      });
    } else {      
      alert('Please fill your email.')
    }    
  }

  // second submit will really to do change password
  changePwdSubmit = (values) => {
    let verifyCode = values.inputVerifyCode;
    let newPassword = values.inputNewPassword;
    let confirmPassword = values.inputConfirmPassword;

    if (newPassword === confirmPassword) {
      this.setState({ loading: true });

      let callback = {
        onSuccess: this.changePwdCallback,
        onFailure: this.changePwdFailCallback
      }
      this.state.cognitoUser.confirmPassword(verifyCode, newPassword, callback);
    } else {
      alert('The new password is inconsistent with the confirmed password.')
    }
  }

  changePwdCallback = () => {
    const { doLogout, match, history } = this.props;
    if (match.path === '/Main/ResetPassword') {
      history.goBack();
    }
    doLogout();
  }

  changePwdFailCallback = (err) => {
    this.setState({ loading: false });
    alert(err.message);
  }

  renderVerifyForm = (handleSubmit, verifyFormPass, isEmailReadonly) => (
    <form className='verify-form' onSubmit={handleSubmit(this.forgotPwdSubmit)}>
      <Field name="inputVerifyEmail" type="email" component={commonRenderInput} validate={verifyAccount} label="Account" placeholder="Please input account" disabled={isEmailReadonly} />
      <div className='area-submit-btn'>
        <Row>
            <Col md={2}>&nbsp;</Col>
            <Col md={8} >
                <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>Reset my password</Button>
            </Col>
            <Col md={2}>&nbsp;</Col>
        </Row>
      </div>
    </form>
  );

  renderChangeForm = (handleSubmit, verifyFormPass) => (
    <form className='change-pwd-form' onSubmit={handleSubmit(this.changePwdSubmit)}>
        <Field name="inputVerifyCode" type="text" component={commonRenderInput} label="Verify Code" placeholder="Enter Verify Code" />
        <Field name="inputNewPassword" type="password" component={commonRenderInput} validate={minLength8} label="New Password" placeholder="Please input the new password" subLabel="(At least 8 characters)" />
        <Field name="inputConfirmPassword" type="password" component={commonRenderInput} validate={[minLength8, verifyPasswordConsistent]} label="Confirm New Password" placeholder="Input the new password again" />
        <div className='area-submit-btn'>
          <Row>
              <Col md={2}>&nbsp;</Col>
              <Col md={8}>
                  <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>Confirm</Button>
              </Col>
              <Col md={2}>&nbsp;</Col>
          </Row>
        </div>
    </form>
  );

  render() {
      const { handleSubmit, verifyFormPass, isEmailReadonly } = this.props;

      let renderForm;
       // has two form, one is change form to set new password.
      if (this.state.displayChangeForm) {
        renderForm = this.renderChangeForm(handleSubmit, verifyFormPass);
      } else {
        // another is enter email and double confirm.
        renderForm = this.renderVerifyForm(handleSubmit, verifyFormPass, isEmailReadonly);
      }

      return (
        <div className='area-forgot-pwd-form form-custom'>
            { renderForm }
            <Loading loading={this.state.loading} center={true}></Loading>
        </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => {
  const verifyFormPass = verifyForm(state.form['ForgotPwdForm']);
  const account = state.logindReducers.account;

  return {
      verifyFormPass : verifyFormPass,
      isEmailReadonly : account ? true : false,
      initialValues: {
        inputVerifyEmail: account ? account.email : ''
      }
  }
};

ForgotPwdForm = reduxForm({
  form: 'ForgotPwdForm',  // a unique identifier for this form
})(ForgotPwdForm)

export default withRouter(connect(
  mapStateToProps,
  { doLogout }
)(ForgotPwdForm));